import { useNavigate } from "react-router-dom";
import AboutMainSection from "./AboutMainSection";
import CallToAction from "./CallToAction";
import WhyChooseUs from "./WhyChooseUs";
import Associates from "./Associates";

const AboutPage = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section about-page-fin">
                <h2 className="other-pages-title">About Us</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/about-money-vision-advisory")} style={{ cursor: "pointer" }}>About us</span>
                </p>
            </div>
            <Associates />
            <div className="about-text-section-fin">
                <p>
                    <strong>India's leading loan distributor:</strong>
                    Money Vision has its presence in all Tier 1 cities across the country, with the partnership of more than 500+ local connectors.
                    Our partners gain exposure to the most dynamic industry and benefit from our strong support system and on-time payouts.
                </p>
                <p>
                    <strong>More than 50,000 satisfied customers:</strong>
                    With branches expanding nationwide, Money Vision ensures quick support and the best-in-class services to our customers.
                    Over the last few years, we have successfully disbursed loans to over 5 Lakh customers, helping them fulfill their financial goals.
                </p>
                <p>
                    <strong>Tie-ups with over 80+ financial institutions:</strong>
                    We have built a trusted network of 80+ reputed lenders across India, ensuring our customers always get the best deals,
                    flexible loan options, and complete transparency.
                </p>
            </div>

            <CallToAction />
        </>
    );
};

export default AboutPage;
